import { Directive, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from './../services/navigation.service';

@Directive({
  selector: '[dynamicNavigation]'
})
export class DynamicNavigationDirective {
  @Input() canHref: boolean;

  constructor(
    private router: Router,
    private _navigationService: NavigationService
  ) { }

  @HostListener('click', ['$event']) onClick(event): void {
      if (!this.canHref) {
        this.cancelClick(event);
        let url: string = event?.target?.getAttribute('href');
        url = url.replace(this._navigationService.getBaseUrlSlug(), '');
        this.router.navigate([url]);
      }
  }

  private cancelClick(event): void {
      event.preventDefault();
      event.stopPropagation();
  }

}
